import script from "./networkCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./networkCard.vue?vue&type=script&lang=ts&setup=true"

import "./networkCard.vue?vue&type=style&index=0&id=80f7f56c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80f7f56c"]])

export default __exports__